import React, { Component } from 'react';
import { PaymentAction } from "../../actions";
import { connect } from "react-redux";
import Select from 'react-select';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import Utility from "../../helpers/Utility";

class PayoutDataInput extends Component {
    state = {
        bank: null,
        account_number: null,
        category: null,
        bundle: null,
        entity_number: null,
        phone: null,
        vend_type: null,
    };

    setOptions = () => {
        const { dispatch, channel } = this.props;
        if (channel === 'bank_transfer') {
            dispatch(PaymentAction.fetchBankList());
        } else {
            dispatch(PaymentAction.fetchVasServices()).then(() => {
                const { vasServices } = this.props;
                const vasServicesData = vasServices?.data?.data?.services;
                const vasService = vasServicesData?.find(service => service.identifier === channel);
                if (vasService) {
                    dispatch(PaymentAction.fetchVasCategories(vasService.id));
                }
            });
        }
    };

    componentDidMount() { this.setOptions(); }

    componentDidUpdate(prevProps) {
        const { channel } = this.props;
        if (channel !== prevProps.channel) {
            this.setState({ bank: null, account_number: null, category: null, bundle: null, entity_number: null, phone: null, vend_type: null });
            this.setOptions();
        }
    }

    resolveAccount = (bankCode, accountNumber) => {
        const { dispatch } = this.props;
        dispatch(PaymentAction.resolveBank(bankCode, accountNumber));
    };

    handleAccountChange = (e) => {
        const accountNumber = e.target.value.replace(/\D/g, '');
        if (accountNumber.length === 10 && this.state.bank) {
            this.setState({ account_number: accountNumber });
            this.resolveAccount(this.state.bank.value, accountNumber);
        }
    };

    verifyEntity = (id, entityNumber) => {
        const { dispatch } = this.props;
        dispatch(PaymentAction.verifyVasEntity(id, entityNumber));
    };

    handleEntityVerification = (e) => {
        const entityNumber = e.target.value.replace(/\D/g, '');
        if (entityNumber.length === (this.props.channel === 'utility' ? 11 : 10) && this.state.category) {
            this.setState({ entity_number: entityNumber });
            this.verifyEntity(this.state.category.value, entityNumber);
        }
    };

    fetchProducts = (categoryId) => {
        const { dispatch } = this.props;
        dispatch(PaymentAction.fetchVasProducts(categoryId));
    };

    render() {
        const { channel, error, bankList, resolveBank, vasServices, vasCategories, vasProducts, verifyVasEntity } = this.props;

        if (channel === 'bank_transfer') {
            const banks = bankList?.data?.data?.banks || [];
            return (
                <div>
                    <div className="ps-form-group">
                        <label className="ps-label">Bank</label>
                        <div className="ps-select">
                            <Select
                                options={banks.map(bank => ({ value: bank.code, label: bank.name }))}
                                isLoading={bankList?.requesting}
                                onChange={(selectedOption) => {
                                    this.setState({ bank: selectedOption });
                                    if (this.state.account_number) {
                                        this.resolveAccount(selectedOption.value, this.state.account_number);
                                    }
                                }}
                                value={this.state.bank}
                                isSearchable
                                placeholder={bankList?.requesting ? 'Loading banks...' : 'Search bank...'}
                                classNamePrefix="react-select"
                                name="bank_code"
                                className={error.bank_code ? 'is-invalid' : ''}
                            />
                        </div>
                        {error.bank_code && <span className="ps-error-text">{error.bank_code}</span>}
                    </div>

                    <div className="ps-form-group">
                        <label className="ps-label">Account Number</label>
                        <input
                            className={`ps-input ${error.account_number ? 'is-invalid' : ''}`}
                            type="text"
                            placeholder="Enter 10-digit account number"
                            disabled={!this.state.bank}
                            onChange={this.handleAccountChange}
                            maxLength={10}
                            name="account_number"
                            style={{ fontFamily: 'var(--font-mono)', letterSpacing: '0.05em' }}
                        />
                        {error.account_number && <span className="ps-error-text">{error.account_number}</span>}
                        {resolveBank?.requesting && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '0.5rem' }}>
                                <span className="ps-spinner ps-spinner-dark" style={{ width: 14, height: 14 }} />
                                <span style={{ fontSize: '11px', color: 'var(--slate-400)' }}>Resolving account...</span>
                            </div>
                        )}
                        {this.state.account_number && resolveBank?.data?.data?.account?.account_name && !resolveBank.requesting && (
                            <span className="ps-success-badge">✓ {resolveBank?.data?.data?.account?.account_name}</span>
                        )}
                        {!resolveBank?.requesting && resolveBank?.data?.message && resolveBank?.data?.status === false && (
                            <span className="ps-error-badge">✗ {resolveBank?.data?.message}</span>
                        )}
                        <input type="hidden" name="bank_name" value={this.state.bank?.label || ''} />
                        <input type="hidden" name="name_session_id" value={resolveBank?.data?.data?.account?.name_session_id || ''} />
                    </div>
                </div>
            );
        }

        const { data: { categories = [] } = {} } = vasCategories?.data || {};
        const { data: { categories: products = [] } = {} } = vasProducts?.data || {};

        return (
            <div>
                <div className="ps-form-group">
                    <label className="ps-label">Vendor</label>
                    <div className="ps-select">
                        <Select
                            options={categories?.map(item => ({ value: item.id, label: `${item.name}${item.description ? ` - ${item.description}` : ''}` }))}
                            isLoading={vasServices?.requesting || vasCategories?.requesting}
                            onChange={(selectedOption) => {
                                this.setState({ category: selectedOption });
                                if (channel === 'data' || channel === 'cabletv') this.fetchProducts(selectedOption.value);
                                if (this.state.entity_number) this.verifyEntity(selectedOption.value, this.state.entity_number);
                            }}
                            value={this.state.category}
                            isSearchable
                            placeholder={(vasServices?.requesting || vasCategories?.requesting) ? 'Loading...' : 'Search vendor...'}
                            classNamePrefix="react-select"
                            name="category_id"
                            className={error.category_id ? 'is-invalid' : ''}
                        />
                    </div>
                    {error.category_id && <span className="ps-error-text">{error.category_id}</span>}
                </div>

                {(channel === 'data' || channel === 'cabletv') && (
                    <div className="ps-form-group">
                        <label className="ps-label">Bundle</label>
                        <div className="ps-select">
                            <Select
                                options={products?.map(item => ({ value: item.bundleCode, label: `${item.validity ?? item.name ?? 'N/A'} - ${(item.amount ? Utility.moneyFormat(item.amount) : null) ?? item.bundleCode ?? 'N/A'}` }))}
                                disabled={!this.state.category}
                                isLoading={vasProducts?.requesting}
                                onChange={(selectedOption) => {
                                    this.setState({ bundle: selectedOption });
                                    if (channel === 'cabletv') this.verifyEntity(selectedOption.value, this.state.entity_number);
                                }}
                                value={this.state.bundle}
                                isSearchable
                                placeholder={vasProducts?.requesting ? 'Loading...' : 'Search bundle...'}
                                classNamePrefix="react-select"
                                name="bundle_code"
                                className={error.bundle_code ? 'is-invalid' : ''}
                            />
                        </div>
                        {error.bundle_code && <span className="ps-error-text">{error.bundle_code}</span>}
                    </div>
                )}

                {(channel === 'airtime' || channel === 'data') && (
                    <div className="ps-form-group">
                        <label className="ps-label">Phone Number</label>
                        <PhoneInput
                            disabled={(channel === 'airtime' ? !this.state.category : (!this.state.category || !this.state.bundle))}
                            placeholder="Enter phone number"
                            country="NG"
                            defaultCountry="NG"
                            value={this.state.phone}
                            onChange={phone => this.setState({ phone: phone ?? '' })}
                        />
                        <span className="ps-error-text">{error.entity_number}</span>
                        <input type="hidden" name="entity_number" value={this.state.phone || ''} />
                    </div>
                )}

                {channel === 'cabletv' && (
                    <div className="ps-form-group">
                        <label className="ps-label">IUC Number</label>
                        <input
                            className={`ps-input ${error.entity_number ? 'is-invalid' : ''}`}
                            type="text"
                            placeholder="Enter IUC number"
                            disabled={!this.state.bundle}
                            onChange={this.handleEntityVerification}
                            name="entity_number"
                        />
                        {error.entity_number && <span className="ps-error-text">{error.entity_number}</span>}
                        {verifyVasEntity?.requesting && (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '0.5rem' }}>
                                <span className="ps-spinner ps-spinner-dark" style={{ width: 14, height: 14 }} />
                                <span style={{ fontSize: '11px', color: 'var(--slate-400)' }}>Resolving IUC number...</span>
                            </div>
                        )}
                        {this.state.entity_number && verifyVasEntity?.data?.data?.entity?.name && !verifyVasEntity?.requesting && (
                            <span className="ps-success-badge">✓ {verifyVasEntity?.data?.data?.entity?.name}</span>
                        )}
                        {!verifyVasEntity?.requesting && verifyVasEntity?.data?.message && verifyVasEntity?.data?.status === false && (
                            <span className="ps-error-badge">✗ {verifyVasEntity?.data?.message}</span>
                        )}
                    </div>
                )}

                {channel === 'utility' && (
                    <>
                        <div className="ps-form-group">
                            <label className="ps-label">Meter Type</label>
                            <div className="ps-select">
                                <Select
                                    options={[{ value: 'PREPAID', label: 'Prepaid' }, { value: 'POSTPAID', label: 'Postpaid' }]}
                                    disabled={!this.state.category}
                                    onChange={selectedOption => this.setState({ vend_type: selectedOption })}
                                    value={this.state.vend_type}
                                    placeholder="Select meter type..."
                                    classNamePrefix="react-select"
                                    name="vend_type"
                                    className={error.vend_type ? 'is-invalid' : ''}
                                />
                            </div>
                            {error.vend_type && <span className="ps-error-text">{error.vend_type}</span>}
                        </div>

                        <div className="ps-form-group">
                            <label className="ps-label">Meter Number</label>
                            <input
                                className={`ps-input ${error.entity_number ? 'is-invalid' : ''}`}
                                type="text"
                                placeholder="Enter meter number"
                                disabled={!this.state.category}
                                onChange={this.handleEntityVerification}
                                name="entity_number"
                            />
                            {error.entity_number && <span className="ps-error-text">{error.entity_number}</span>}
                            {verifyVasEntity?.requesting && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '0.5rem' }}>
                                    <span className="ps-spinner ps-spinner-dark" style={{ width: 14, height: 14 }} />
                                    <span style={{ fontSize: '11px', color: 'var(--slate-400)' }}>Resolving meter number...</span>
                                </div>
                            )}
                            {this.state.entity_number && verifyVasEntity?.data?.data?.entity?.name && !verifyVasEntity?.requesting && (
                                <span className="ps-success-badge">✓ {verifyVasEntity?.data?.data?.entity?.name} - {verifyVasEntity?.data?.data?.entity?.address?.trim()}</span>
                            )}
                            {!verifyVasEntity?.requesting && verifyVasEntity?.data?.message && verifyVasEntity?.data?.status === false && (
                                <span className="ps-error-badge">✗ {verifyVasEntity?.data?.message}</span>
                            )}
                            <input type="hidden" name="provider_name" value={this.state.category?.label || ''} />
                        </div>
                    </>
                )}
            </div>
        );
    }
}

export default connect(function (state) {
    return {
        bankList: state.bankList,
        resolveBank: state.resolveBank,
        vasServices: state.vasServices,
        vasCategories: state.vasCategories,
        vasProducts: state.vasProducts,
        verifyVasEntity: state.verifyVasEntity,
    }
})(PayoutDataInput);
